import { Component, OnInit } from '@angular/core';
import { PricelistDownloadFilterComponent } from './pricelist-download-filter/pricelist-download-filter.component';
import { debounceTime, filter, distinctUntilChanged, map, finalize } from 'rxjs/operators';
import { PricelistDownloadService } from './pricelist-download.service';
import { DialogService, LanguageService, HelperService, AuthService } from 'src/app/services';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'esc-pricelist-download',
  templateUrl: './pricelist-download.component.html',
  styleUrls: ['./pricelist-download.component.scss']
})
export class PricelistDownloadComponent implements OnInit {

  public listData = [];
  public listLength = 0;
  private currentFilters;
  private previousFilters;
  public filterNumber: number = 0;
  public selectedRow;
  exportData = [];
  public loading = {
    init: false,
    more: false,
    download: false,
    error: false,
  };
  private listSub: Subscription;
  public form: FormGroup;
  public constants = ConstantsHelper;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  displayedColumns: string[] = ['chain_code', 'chain_description', 'branch_code', 'branch_description', 'category_code', 'category_description', 'brand_code', 'brand_description', 'item_code', 'item_description', 'price', 'effectivity_start_date',  'effectivity_end_date', 'status'];

  constructor(
    private fb: FormBuilder,
    public media: MediaObserver,
    private helper: HelperService,
    public authService: AuthService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public plDownloadSvc: PricelistDownloadService,
    ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    setTimeout(() => {
      this.openFilter();
    }, 100);
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  initForm() {
    this.form = this.fb.group({
      searchTerm: [null],
    });
  }

  getListData() {
    this.currentFilters.web_filter.is_download = 0;

    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    this.listSub = this.plDownloadSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.get(res, 'count');
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      });
  }

  getMoreData() {
    if (this.loading.more || this.loading.init || this.listData.length >= this.listLength) {
      return;
    }
    this.currentFilters.web_filter.offset += this.currentFilters.web_filter.limit;
    this.getListData();
  }

  openFilter() {
    let dialogRef: MatDialogRef<PricelistDownloadFilterComponent>;
    dialogRef = this.dialogService.openDialog(PricelistDownloadFilterComponent, {
      width: '500px',
      autoFocus: false,
      disableClose: false,
      data: _.get(this, 'previousFilters') || _.get(this, 'currentFilters')
    });
    dialogRef.afterClosed().subscribe((selectedFilters) => {
      if(selectedFilters) {
        this.previousFilters = _.cloneDeep(selectedFilters);
        this.currentFilters.web_filter.chain_id = _.get(selectedFilters, 'chain.id');

        this.currentFilters.web_filter.branch_id = _.get(selectedFilters, 'branch.id') || 0;

        this.currentFilters.web_filter.category_id =  _.get(selectedFilters, 'category.id') || 0;

        this.currentFilters.web_filter.brand_id =  _.get(selectedFilters, 'brand.id') || 0;

        this.currentFilters.web_filter.sku_id =  _.get(selectedFilters, 'item.id') || 0;

        this.currentFilters.web_filter.options =  _.get(selectedFilters, 'option.code');

        this.currentFilters.web_filter.from_start_date =  _.get(selectedFilters, 'from_effectivity_start_date') ? moment(_.get(selectedFilters, 'from_effectivity_start_date')).format("YYYY-MM-DD") : "0";

        this.currentFilters.web_filter.from_end_date =  _.get(selectedFilters, 'from_effectivity_end_date') ? moment(_.get(selectedFilters, 'from_effectivity_end_date')).format('YYYY-MM-DD') : "0";

        this.currentFilters.web_filter.to_start_date =  _.get(selectedFilters, 'to_effectivity_start_date') ? moment(_.get(selectedFilters, 'to_effectivity_start_date')).format('YYYY-MM-DD') : "0";

        this.currentFilters.web_filter.to_end_date =  _.get(selectedFilters, 'to_effectivity_end_date') ? moment(_.get(selectedFilters, 'to_effectivity_end_date')).format('YYYY-MM-DD') : "0";

        this.currentFilters.web_filter.status =  _.get(selectedFilters, 'status.code');
        this.refresh();
      }
    })
  }

  detectFormChanges() {
    this.form.get('searchTerm').valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.currentFilters.web_filter.keyword = _.toString(value);
      this.refresh();
    });
  }

  download() {
    this.currentFilters.web_filter.is_download = 1;
    this.currentFilters.web_filter.offset = 0;
    this.currentFilters.web_filter.limit = 9999999;
    this.loading.download = true;
    this.listSub = this.plDownloadSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.loading.download = false;
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        ​if (_.has(res, 'value') && (res.value == "Success")) {
          this.helper.openDownloadMenu(res)
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        this.loading.error = true;
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
        return observableOf(null);
      });
  }
  
  refresh() {
    this.listData = [];
    this.listLength = 0;
    this.currentFilters.web_filter.offset = _.clone(INITIAL_OPTIONS.web_filter.offset);
    this.currentFilters.web_filter.limit = _.clone(INITIAL_OPTIONS.web_filter.limit);
    this.getListData();
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    offset: 0,
    limit: 50,
    keyword: "",
    chain_id: 0,
    branch_id: 0,
    category_id: 0,
    brand_id: 0,
    sku_id: 0,
    options: 0,
    from_start_date: "0",
    to_start_date: "0",
    from_end_date: "0",
    to_end_date: "0",
    status: 0,
    is_download: 0,
    is_asc: 1,
    getMore: true
  }
}